<script setup lang="ts">
withDefaults(
  defineProps<{
    /** `div` is a static rail; `button` makes the whole rail one press target, which takes `aria-expanded` and the like. */
    as?: 'div' | 'button'
  }>(),
  { as: 'div' },
)

defineSlots<{
  /** `AppCarvedRailChip`s, then any plain trailing note such as a count or a chevron. */
  default(): unknown
}>()
</script>

<template>
  <component
    :is="as"
    :type="as === 'button' ? 'button' : undefined"
    class="flex max-w-full items-center gap-2 overflow-hidden rounded-full bg-bg-tertiary p-2 text-left text-caption text-text-secondary inset-shadow-press"
    :class="
      as === 'button' &&
      'cursor-pointer outline-none transition-colors duration-fast ease-soft hovered:text-text-primary focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-accent-blue motion-reduce:transition-none'
    "
  >
    <slot />
  </component>
</template>
